export enum Tax02 {
  AgriculturalBusinessAndManagement = 2,
  AnimalSciences = 3,
  ArchitectureDesignPlanning = 4,
  AreaEthnicCulturalandGenderStudies = 5,
  BehavioralSciences = 6,
  BiologicalSciences = 7,
  BiomedicalSciences = 8,
  Communication = 9,
  ComputerandInformationSciences = 10,
  CropPlantandSoilSciences = 11,
  EarthandSpaceSciences = 12,
  FamilyandHumanSciences = 13,
  FoodScience = 14,
  LanguagesAndLiteratures = 15,
  MathematicalSciences = 16,
  PhysicalSciences = 17,
  SocialSciences = 18,
  VisualAndPerformingArts = 19,
  GeneralAgriculturalSciences = 112,
  Business = 114,
  Education = 115,
  Engineering = 116,
  HealthProfessionsSciences = 118,
  GeneralHumanities = 119,
  NaturalResourcesandConservation = 120,
}
export const Tax02NameMap: Map<number, string> = new Map([
  [
    Tax02.AgriculturalBusinessAndManagement,
    'Agricultural Business and Management',
  ],
  [Tax02.AnimalSciences, 'Animal Sciences'],
  [Tax02.ArchitectureDesignPlanning, 'Architecture, Design, Planning'],
  [
    Tax02.AreaEthnicCulturalandGenderStudies,
    'Area, Ethnic, Cultural and Gender Studies',
  ],
  [Tax02.BehavioralSciences, 'Behavioral Sciences'],
  [Tax02.BiologicalSciences, 'Biological Sciences'],
  [Tax02.BiomedicalSciences, 'Biomedical Sciences'],
  [Tax02.Communication, 'Communication'],
  [Tax02.ComputerandInformationSciences, 'Computer and Information Sciences'],
  [Tax02.CropPlantandSoilSciences, 'Crop, Plant and Soil Sciences'],
  [Tax02.EarthandSpaceSciences, 'Earth and Space Sciences'],
  [Tax02.FamilyandHumanSciences, 'Family and Human Sciences'],
  [Tax02.FoodScience, 'Food Science'],
  [Tax02.LanguagesAndLiteratures, 'Languages and Literatures'],
  [Tax02.MathematicalSciences, 'Mathematical Sciences'],
  [Tax02.PhysicalSciences, 'Physical Sciences'],
  [Tax02.SocialSciences, 'Social Sciences'],
  [Tax02.VisualAndPerformingArts, 'Visual and Performing Arts'],
  [Tax02.GeneralAgriculturalSciences, 'General Agricultural Sciences'],
  [Tax02.Business, 'Business'],
  [Tax02.Education, 'Education'],
  [Tax02.Engineering, 'Engineering'],
  [Tax02.HealthProfessionsSciences, 'Health Professions Sciences'],
  [Tax02.GeneralHumanities, 'General Humanities'],
  [Tax02.NaturalResourcesandConservation, 'Natural Resources and Conservation'],
]);
